import { PRODUCT_DATA } from "../constants/action-types";

export const uploadProductData = (result) => {
    return {
        type: PRODUCT_DATA.UPLOAD.START,
        payload: { url: "/api/v3.0/vetl/product-data/upload", body: JSON.stringify(result) },
    };
};

export const startProductDataUploadJobPolling = (payload) => ({ type: PRODUCT_DATA.JOB.POLL.START, payload });

export const fetchProductDataUploadJob = (jobId: string, pipelineId: string) => ({
    type: PRODUCT_DATA.JOB.FETCH.START,
    payload: { url: "/api/v3.0/vetl/job", body: { jobId, pipelineId } },
});

export const resetUploadJob = () => ({ type: PRODUCT_DATA.JOB.RESET });

export const exportProductData = (options) => ({
    type: PRODUCT_DATA.EXPORT.DOWNLOAD.START,
    payload: { url: "/api/v3.0/items/export", body: JSON.stringify(options) },
});

export const resetExportData = () => ({ type: PRODUCT_DATA.EXPORT.RESET });

export const archiveAllProducts = () => ({
    type: PRODUCT_DATA.ARCHIVE.START,
    payload: { url: "/products/archive-all" },
});
